import { SettingsProviderService } from './settings-provider.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";


export class BaseApiService {

  constructor(protected http: HttpClient, protected settingsProvider: SettingsProviderService, private controllerName: string ) { }

  protected get baseUrl(): string {
    return `${this.settingsProvider.baseApiUrl}/${this.controllerName}/`;
  }

  protected post<T>(urlPart: string, body: any = null): Observable<T>{
    return this.http.post<T>(this.baseUrl + urlPart, body);
  }

  protected get<T>(urlPart: string): Observable<T>{
    return this.http.get<T>(this.baseUrl + urlPart);
  }
}
